import request from '@/lib/request/';

const baseUri = 'auth/logout';

/**
 * @param data {Object}
 * @returns {Promise}
 */
export function post() {
  return request({
    url: baseUri,
    method: 'post',
  });
}
